import {NgModule} from '@angular/core';

import {MatchPhasePipe} from './match-phase.pipe';
import {DateMatchPipe} from '@tisa-group/core/pipes/date-match';

@NgModule({
  declarations: [MatchPhasePipe],
  exports: [MatchPhasePipe],
  providers: [DateMatchPipe],
})
export class MatchPhaseModule {}
